var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRowBelow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5708H16V2.5708H2V8.5708ZM0 18.5708V0.570801H18V18.5708H14V16.5708H16V10.5708H2V16.5708H4V18.5708H0ZM8 20.5708V18.5708H6V16.5708H8V14.5708H10V16.5708H12V18.5708H10V20.5708H8Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRowBelow);
export default __webpack_public_path__ + "static/media/add_row_below.eb8b055ec7d62bb63e00ffd4e4938c37.svg";
export { ForwardRef as ReactComponent };